import { endpoints } from "../../../configs/Settings";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";
import { HTTPResponseStatus } from "../../../utils/enum";
import * as uuid from "uuid";
import { toast } from "react-toastify";

export async function PostSchedule(objData: any, reference: any) {
  const uuidValue = uuid.v1();
  const url = `${endpoints.WORKFLOWFHIR}/Schedule/${uuidValue}`;

  const data = auxiliarData.Schedule(objData, reference, uuidValue);
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .put(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`PutSchedule: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostSchedule ", error);
      // toast.error(`PostSchedule Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
